import { useFormContext } from 'react-hook-form'
import DateInput from '@components/form/DateInput'
import useT from '@hooks/useTranslation'

const ContextDateInput = ({ t, ...rest }) => {
    const methods = useFormContext()
    const label = useT(t) || rest.name

    return <DateInput {...rest}
        label={label}
        methods={methods}
        register={methods.register} />
}

export default ContextDateInput